import {
  GetShortFallResponse,
  ShortFallProps,
} from '../../../types/ShortfallTrackerReport/shortfallTrackerTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../utils/apiUtils'
import { AllowedHttpMethods, shortFallReportApiConfig } from '../apiList'

const getShortFallList = async (
  props: ShortFallProps,
): Promise<GetShortFallResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: shortFallReportApiConfig.getShortFallList,
    method: AllowedHttpMethods.get,
    params: {
      endIndex: props.endIndex ?? 20,
      startIndex: props.startIndex ?? 0,
      shortlisted: props.shortlisted,
      startDate: props.startDate,
      endDate: props.endDate,
      dateSelection: props.dateSelection,
      billingType: props.billingType,
      search: props.search,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const exportShortFallList = async (
  props: ShortFallProps,
): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: shortFallReportApiConfig.exportShortFallList,
    method: AllowedHttpMethods.get,
    params: {
      startDate: props.startDate,
      endDate: props.endDate,
      shortlisted: props.shortlisted,
      dateSelection: props.dateSelection,
      billingType: props.billingType,
      search: props.search,
    },
    responseType: 'blob',
  })

  const response = await useAxios(requestConfig)
  return response.data
}

export const shortFallApi = {
  getShortFallList,
  exportShortFallList,
}
